import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "redux/typedUseSelector";

import GlassPopup from "components/GlassPopup/GlassPopup";
import profileActions from "redux/ducks/profile/profileActions";

import verifyBadge from "images/Icons/verified-badge-oil.png";
import clockIcon from "images/Icons/clock-new.png";

// Анти-скам попап 1в1 с приложением (screens/female-verify-modal):
//  - pending: селфи уже на проверке → «Фото на проверке, дождитесь» + «Понятно»
//    (повторно на верификацию НЕ гоним);
//  - verify: «Подтвердите профиль» → «Пройти верификацию» (добровольный режим
//    со стрелкой «назад») или «Отмена».
function FemaleVerifyModal() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const mode = useSelector((state) => state.profileReducer.femaleVerifyModal);

  if (!mode) return null;

  const close = () => dispatch(profileActions.setFemaleVerifyModal(null));

  if (mode === "pending") {
    return (
      <GlassPopup
        visible
        centered
        image={clockIcon}
        title={t("verificationBadge.owner.pending.title")}
        description={t("verificationBadge.owner.pending.description")}
        primaryText={t("verificationBadge.ok")}
        onPrimary={close}
        onClose={close}
      />
    );
  }

  const goVerify = () => {
    close();
    history.push("/fill/verifyphoto", { withBackButton: true });
  };

  return (
    <GlassPopup
      visible
      centered
      image={verifyBadge}
      title={t("auth.verificationTitle")}
      description={t("profile.verifyPrompt.notes")}
      primaryText={t("messages.verificationRequired.buttonVerifyLabel")}
      onPrimary={goVerify}
      secondaryText={t("common.cancel")}
      onSecondary={close}
      onClose={close}
    />
  );
}

export default FemaleVerifyModal;
